import { Box } from '@mui/material';

const PanelContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{
        pl: 2,
        pr: 2,
        pt: 2,
        width: 620,
        borderStyle: 'solid',
        borderLeftWidth: 1,
        borderBottomWidth: 0,
        borderTopWidth: 0,
        borderRightWidth: 0,
        borderColor: 'divider',
        minHeight: 0,
        boxShadow: 10,
        zIndex: 100,
        overflowY: 'auto',
        overflowX: 'hidden'
      }}
    >
      {children}
    </Box>
  );
};
export default PanelContainer;
